/**
 * Récupère les variables d'environnement runtime
 * En production Docker: injectées via /public/runtime-config.js au démarrage
 * En dev local: utilise process.env directement
 */
if (typeof window !== 'undefined') {
    window.__ENV = window.__ENV || {};
}

const PREPROD_ENV_PATTERN = /(^|[^a-z0-9])preprod([^a-z0-9]|$)/i;

export function getRuntimeConfig() {
    // En client-side, utiliser window.__ENV si disponible
    if (typeof window !== 'undefined' && window.__ENV && Object.keys(window.__ENV).length > 0) {
        return window.__ENV;
    }
  
    // Fallback sur process.env (SSR ou dev local)
    return {
        NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL || '',
        NEXT_PUBLIC_APP_ORIGIN: process.env.NEXT_PUBLIC_APP_ORIGIN || '',
        NEXT_PUBLIC_CHAT_API_URL: process.env.NEXT_PUBLIC_CHAT_API_URL || '',
        NEXT_PUBLIC_DEMO_MODE: process.env.NEXT_PUBLIC_DEMO_MODE || 'false',
        NEXT_PUBLIC_ID_APP_BOOND: process.env.NEXT_PUBLIC_ID_APP_BOOND || '',
        NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV || '',
    };
}

export function getPublicApiUrl() {
    return (getRuntimeConfig().NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');
}

export function getServerApiUrl() {
    if (typeof window !== 'undefined') {
        return getPublicApiUrl();
    }

    return (process.env.SERVER_API_URL || process.env.NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');
}

export function getPublicAppOrigin() {
    return getRuntimeConfig().NEXT_PUBLIC_APP_ORIGIN || '';
}

export function getPublicChatApiUrl() {
    return (getRuntimeConfig().NEXT_PUBLIC_CHAT_API_URL || '').replace(/\/$/, '');
}

export function isPreprodEnvironment() {
    const runtimeConfig = getRuntimeConfig();
    return [
        runtimeConfig.NEXT_PUBLIC_ENV,
        runtimeConfig.NEXT_PUBLIC_APP_ORIGIN,
        runtimeConfig.NEXT_PUBLIC_API_URL,
        runtimeConfig.NEXT_PUBLIC_CHAT_API_URL,
    ]
        .filter(Boolean)
        .some((value) => PREPROD_ENV_PATTERN.test(String(value).toLowerCase()));
}

export const config = getRuntimeConfig();
